
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/word-search",
      function () {
        return require("private-next-pages/games/word-search/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/word-search"])
      });
    }
  